import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { openGoogleMapByLatLngPlaceId } from 'src/app/helpers/helpers';
import { EventListPublishInstance } from 'globals/store/share.event-lists.data';
import { publicHelpers } from './../../helpers/public-helpers';
import { Venue } from 'globals/store/events.data';
import { SmallButtonComponent } from '../buttons/small-button.component';
import { CommonModule } from '@angular/common';
import { PublishLinkListFixPipe } from 'src/app/services/pipes/publishLinkFix.pipe';
import { SafeUrlPipe } from 'src/app/services/pipes/safeUrlPipe.pipe';

// extracted for ease of typing across multiple lists
@Component({
    selector: 'event-list-instances',
    template: `
<div class="missing" *ngIf="!instanceList.length && !loading">There are no {{ missingName }}.</div>
<div class="card" *ngFor="let instance of instanceList; trackBy: trackByEventId">
  <ng-container *ngIf="{ d: instance.dateBlocks, hasDates: !!instance.dates && instance.dateBlocks } as v">
    <img class="top" [src]="instance.thumbnail || 'assets/placeholder_event_list.png'" (click)="editEventThumbnail.emit(instance)" />
    <div class="bottom">
      <h3 class="event-title" *ngIf="!!instance.eventName">{{ instance.eventName }}</h3>
      <ng-container *ngFor="let publish of instance.publishes; trackBy: trackById">
        <a class="title" target="_blank" [href]="!publish.publishLink ? null : (publish.publishLink | publishLinkListFix | safeUrl)" [ngClass]="{ link: !!publish.publishLink }">{{ publish.name }}</a>
        <div class="date-venue" *ngIf="!!publish.dateString || !!publish.venue">
          <ng-container *ngIf="!!publish.dateString">{{ publish.dateString }}</ng-container>
          <ng-container *ngIf="!!publish.venue">
            <ng-container *ngIf="!!publish.dateString"><br/></ng-container> 
            <a class="link" target="_blank" [href]="'https://www.google.com/maps/place/?q=place_id:' + publish.venue.googleId">{{ publish.venue.venue }}</a>
          </ng-container>
        </div>          
        <div class="ctas" *ngIf="!!publish.CTALinks?.length">
          <small-button *ngFor="let link of publish.CTALinks" (click)="helpers.openInNewTab(link.linkUrl)">
            {{ link.filename }}
          </small-button>
        </div>
      </ng-container> 
    </div> 
  </ng-container>
</div>
`,
    styleUrls: ['./event-list-instances.scss'],
    standalone: true,
    imports: [SmallButtonComponent, CommonModule, PublishLinkListFixPipe, SafeUrlPipe, SmallButtonComponent],
})
export class EventListInstancesComponent {
  @Input() instanceList: EventListPublishInstance[]
  @Input() missingName: string
  @Input() loading = true
  @Output() editEventThumbnail: EventEmitter<EventListPublishInstance> = new EventEmitter()

  helpers = publicHelpers

  trackByEventId(index, instance: EventListPublishInstance) {
    return instance.eventId
  }

  trackById<T extends { id: string }>(index, object: T) {
    return object.id
  }

  trackByIndex(index) {
    return index
  }

  openVenue(venue: Venue) {
    const { googleId } = venue
    if (!googleId) {
      console.log("VENUE MISSING PLACE ID!", venue)
      return
    }
    openGoogleMapByLatLngPlaceId(googleId)
  }

}

